/*eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const opsManagerSlice = createSlice({
  name: 'opsManager',
  initialState: {
    opsList: [],
    selectedOpsManager: null,
    selectedId: null, // ✅ new field
  },
  reducers: {
    setOpsList: (state, action) => {
      state.opsList = action.payload;
    },
    setSelectedOpsManager: (state, action) => {
      state.selectedOpsManager = action.payload;
    },
    clearSelectedOpsManager: (state) => {
      state.selectedOpsManager = null;
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    clearSelectedId: (state) => {
      state.selectedId = null;
    },
  },
});

export const {
  setOpsList,
  setSelectedOpsManager,
  clearSelectedOpsManager,
  setSelectedId,
  clearSelectedId,
} = opsManagerSlice.actions;

export default opsManagerSlice.reducer;
